import {
  Button,
  Field,
  Input,
  Stack,
  InputGroup,
} from '@chakra-ui/react';
import { LuLock, LuMail, LuUserRound } from 'react-icons/lu';
import PasswordInput from '@/components/PasswordInput';
import GoogleLoginButton from '@/components/GoogleLoginButton';
import AuthContainer from '@/components/AuthContainer';
import { BsArrowLeft } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import ConfirmActionDialog from '@/components/ConfirmActionDialog'
import useForm from './useForm'

const Registration = () => {
  const navigate = useNavigate();

  const { onSubmit, isPending, showConfirmation, validationErrors } = useForm();

  return (
    <AuthContainer title="Faça sua conta!" subtitle="Crie uma conta para acessar o StageBook.">
      <form onSubmit={onSubmit}>
        <Stack gap="5">
          <Field.Root invalid={!!validationErrors?.name}>
            <Field.Label>Nome completo</Field.Label>
            <InputGroup startElement={<LuUserRound />} width="full" gap={0}>
              <Input name="name" placeholder="Ex: Marco Antônio Guedes" minLength={3} maxLength={150} variant="subtle" bg="gray.200" required />
            </InputGroup>
            {validationErrors?.name?.map((error, index) => (
              <Field.ErrorText key={index}>{error}</Field.ErrorText>
            ))}
          </Field.Root>
          <Field.Root invalid={!!validationErrors?.email}>
            <Field.Label>E-mail</Field.Label>
            <InputGroup startElement={<LuMail />} width="full" gap={0}>
              <Input name="email" type="email" placeholder="exemplo@email.com" variant="subtle" bg="gray.200" required />
            </InputGroup>
            {validationErrors?.email?.map((error, index) => (
              <Field.ErrorText key={index}>{error}</Field.ErrorText>
            ))}
          </Field.Root>
          <Field.Root invalid={!!validationErrors?.password}>
            <Field.Label>Senha</Field.Label>
            <InputGroup startElement={<LuLock />} width="full" gap={0}>
              <PasswordInput
                name="password"
                placeholder="••••••••"
                minLength={8}
                variant="subtle"
                bg="gray.200"
                required
              />
            </InputGroup>
            {validationErrors?.password?.map((error, index) => (
              <Field.ErrorText key={index}>{error}</Field.ErrorText>
            ))}
          </Field.Root>

          <Field.Root>
            <Field.Label>Confirmar senha</Field.Label>
            <InputGroup startElement={<LuLock />} width="full" gap={0}>
              <PasswordInput name="confirmPassword" placeholder="••••••••" minLength={8} variant="subtle" bg="gray.200" required />
            </InputGroup>
          </Field.Root>
          <Button
            type="submit"
            loading={isPending}
            disabled={isPending}
          >
            Cadastrar
          </Button>

          <GoogleLoginButton />

          <Button variant="ghost" textDecoration="underline" onClick={() => navigate('/', { replace: true })}>
            <BsArrowLeft /> Voltar para login
          </Button>
        </Stack>
      </form>
      {showConfirmation && (
        <ConfirmActionDialog
          open
          onOpenChange={() => navigate('/', { replace: true })}
          title="Cadastro realizado!"
          body="Sua conta foi criada com sucesso. Faça login para continuar."
          onConfirm={() => navigate('/', { replace: true })}
          confirmLabel="Fazer login"
          hideCancelButton
          size="md"
        />
      )}
    </AuthContainer>
  );
};

export default Registration;
